<template>
    <v-row>
        <v-col class="py-0">
            <view-card headline="견적신청상태" :hasText="false" titleAlign="baseline" :disabled="!isAdmin">
                <template slot="buttons">
                    <v-spacer></v-spacer>
                    <v-select v-model="inquiry.status" @input="saveStatus" :items="statuses" item-text="text" item-value="value" hide-details class="py-0 mr-3" />
                </template>
            </view-card>
        </v-col>
        <v-col class="py-0">
            <view-card headline="계약유형" :hasText="false" titleAlign="baseline" :disabled="!isAdmin">
                <template slot="buttons">
                    <v-spacer></v-spacer>
                    <v-select v-model="inquiry.inquiryResultType" @input="saveInquiryResultType" :items="inquiryResultTypes" item-text="text" item-value="value" hide-details class="py-0 mr-3" />
                </template>
            </view-card>
        </v-col>

        <!-- <view-card :headline="'견적신청상태'">
            <v-row>
                <v-col v-for="{ text, value } in statuses" :key="value" class="mb-6 py-0 caption d-flex flex-column justify-end align-center">
                    <label :for="value" style="white-space:pre-wrap; text-align:center;">{{ text }}</label>
                    <v-checkbox v-model="inquiry.status" :value="value" @change="save" hide-details :readonly="!isAdmin" color="green" class="py-0" />
                </v-col>
            </v-row>
        </view-card> -->
    </v-row>
</template>
<script>
import viewCard from "../dumb/view-card.vue";
export default {
    components: { viewCard },
    props: { value: Object, isAdmin: { type: Boolean, default: false } },
    data() {
        return {
            inquiry: this.$props.value,
            statuses: [
                { text: "견적신청", value: "견적신청" },
                { text: "견적 요청중\n(알림톡발송)", value: "견적요청중" },
                { text: "추가견적 요청중\n(알림톡발송)", value: "추가견적요청중" },
                { text: "실측일정확인", value: "실측일정확인" },
                { text: "실측완료", value: "실측완료" },
                { text: "계약진행중", value: "계약진행중" },
                { text: "계약완료", value: "계약완료" },
                { text: "취소\n(보류)", value: "취소" },
            ],
            inquiryResultTypes: [
                { text: "없음", value: null },
                { text: "일반계약", value: "일반계약" },
                { text: "안심계약", value: "안심계약" },
            ],
        };
    },
    methods: {
        saveStatus(value) {
            this.$emit("change", { status: value, message: "상태가 변경되었습니다." });
        },
        saveInquiryResultType(value) {
            this.$emit("change", { inquiryResultType: value, message: "계약유형이 변경되었습니다." });
        },
    },
    watch: {
        value() {
            this.inquiry = this.value;
        },
    },
};
</script>
